// TODO: refactor to artbasel-lib-platform
export const imageDimensions = async (event: ProgressEvent<FileReader>): Promise<{ width: number; height: number }> => {
  const fileReader = event.target as FileReader;
  const imageSource = fileReader.result as string;

  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = reject;
    image.src = imageSource;
  });
};

export const imageDimensionsByUrl = async (imageUrl: string): Promise<{ width: number; height: number }> => {
  return await imageDimensions({ target: { result: imageUrl } } as ProgressEvent<FileReader>);
};

export const videoDimensionsByUrl = async (videoUrl: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        // duration: video.duration, // TODO: uncomment if we happen to support this.
      });

      // The following three lines should stop loading the video
      video.pause();
      video.removeAttribute('src');
      video.load();
    };
    video.onerror = reject;
    video.src = videoUrl;
  });
};

// TODO: refactor to artbasel-lib-platform
export const isImageFormatByExtension = (fileNameOrUrl: string, extensionWhiteList?: string[]): boolean => {
  const fallbackWhitelist = ['jpg', 'jpeg', 'jpe', 'jpeg2000', 'png', 'gif', 'svg', 'webp', 'bmp', 'tiff'];
  const extensions = extensionWhiteList || fallbackWhitelist;
  const hasNameAndExtension =
    (((fileNameOrUrl || '').split('?')[0] || '').split(/\\|\//).pop() || '').split('.').filter((x) => x).length > 1;
  return (hasNameAndExtension && extensions.includes((fileNameOrUrl.split('.').pop() || '').toLowerCase())) || false;
};
